// Gets the domain from the provided URL

function getDomain(url) {
  const prefix = /^https?:\/\//i;
  const domain = /^[^\/:]+/;

  url = url.replace(prefix, '');

  if (url.charAt(0) === '/') {
    url = window.location.hostname + url;
  }

  const match = url.match(domain);
  if (match) {
    return match[0];
  }

  return null;
}

// Shows the leave site notice, using the provided anchor
function showLeaveSiteNotice(anchor) {
  const url = anchor.attributes['href'].value;
  const target = anchor.attributes['target'] ? anchor.attributes['target'].value : "";

  document.getElementById("speedBumpTrigger").click();


  document.getElementById('continueToSite').setAttribute('href', url);
  document.getElementById('continueToSite').setAttribute('target', target);

  document.getElementById('continueToSite').addEventListener('click', (e) => {
    document.querySelector("[data-bs-dismiss=modal]").click();
  });
}

// Click event for page anchors
document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll("a[href^=http]").forEach(anchor => {
    window.wf ??= {};
    window.wf.whiteList ??= [];
    const domain = getDomain(anchor.getAttribute('href'));
    const isWhitelisted = window.wf.whiteList.some(res => res === domain || 'www.' + res === domain);
    if (domain != location.hostname && !isWhitelisted) {
      if (!isWhitelisted) {
        anchor.addEventListener('click', (e) => {
          e.preventDefault();
          showLeaveSiteNotice(anchor);
        });
      }
    }
  });
});
